import type { Exam } from '@mathflat/domain/Exam'
import {
  type StudentExam,
  studentExamApi,
  type StudentExamScoringPayload,
  type StudentExamScoringSummary,
} from '@mathflat/domain/StudentExam'

import { mpEventInfo } from '@/constant'
import { GroupStudentProblem } from '@/dto'

class ExamGroupScoringController {
  adapter = {
    scoringSummaryToGroupStudentProblem: {
      from: (data: StudentExamScoringSummary) => {
        return new GroupStudentProblem({
          id: data.studentExamId,
          studentId: data.studentId,
          studentName: data.studentName,
          scoringList: data.scoringList.map((scoring) => ({
            examProblemId: scoring.examProblemId,
            result: scoring.result,
            score: scoring.score,
          })),
        })
      },
    },
  }

  patchStudentScoring = async (
    studentExamId: StudentExam['id'],
    payload: StudentExamScoringPayload,
  ) => {
    await studentExamApi.scoreStudentExam(studentExamId, payload, {
      mp_event_name: mpEventInfo.학력평가_시험지채점,
    })
  }

  fetchScoringSummary = async (examId: Exam['id'], studentExamIds: StudentExam['id'][]) =>
    studentExamApi.getExamScoringSummary({ examId, studentExamIds })

  fetchScoringSummaryToGroupStudentProblem = async (
    examId: Exam['id'],
    studentExamIds: StudentExam['id'][],
  ) => {
    const { studentExamScoringSummary, problems } = await this.fetchScoringSummary(
      examId,
      studentExamIds,
    )

    const parseData = studentExamScoringSummary.map(
      this.adapter.scoringSummaryToGroupStudentProblem.from,
    )

    return {
      problems,
      scoringSummaryToGroupStudentProblem: parseData.sort((a, b) =>
        a.studentName > b.studentName ? 1 : a.studentName < b.studentName ? -1 : 0,
      ),
    }
  }
}

export const examGroupScoringController = new ExamGroupScoringController()
